// extracted by mini-css-extract-plugin
export default {"modalwrapper":"Modal_modalwrapper__hKy2o","modalwrapper_open":"Modal_modalwrapper_open__ydaby","modal":"Modal_modal__RvMn0","closebutton":"Modal_closebutton__inXef"};